import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import ProdutoServicoTipoObjetoService from "../../services/ProdutoServicoTipoObjetoService";
import CrudForm from "../../components/forms/custom/CrudForm";
import InputCheckSwitch from "../../components/forms/elements/InputCheckSwitch";

class FormProdutoServicoTipoObjeto extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idProdutoServicoTipoObjeto: "",
            nome: "",
            flLargura : false,
            flAltura : false,
            flComprimento : false,
            flDiametro : false,
        };

        this.state.crud = {
            service: ProdutoServicoTipoObjetoService,
            labels: {
                title: 'Tipo de Objeto',
            },
            urlList: '/LstProdutoServicoTipoObjeto',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <>
                <div className="row mb-3 g-3">
                    <InputText label="Código" md={3} value={this.state.model.idProdutoServicoTipoObjeto} name="idProdutoServicoTipoObjeto" readOnly opcionalLabel={false} />
                    <InputText label="Nome do Tipo de Objeto" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
                </div>
                <div className="row mx-1 mb-3">
                    <InputCheckSwitch label="Tem informação de Largura?" name="flLargura" checked={Boolean(this.state.model.flLargura)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Tem informação de Altura?" name="flAltura" checked={Boolean(this.state.model.flAltura)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Tem informação de Comprimento?" name="flComprimento" checked={Boolean(this.state.model.flComprimento)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Tem informação de Diâmetro?" name="flDiametro" checked={Boolean(this.state.model.flDiametro)} onChange={this.handleChange} />
                </div>
            </>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormProdutoServicoTipoObjeto {...props} navigate={navigate} params={params} />
}

export default With